// // CustomPagination.jsx
// import React, { useEffect, useState } from "react";

// const CustomPagination = ({ gridApi }) => {
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const visiblePages = 5; // कितने pages एक साथ दिखाने हैं

// useEffect(() => {
//   if (!gridApi) return;

//   const updatePagination = () => {
//     setTotalPages(gridApi.paginationGetTotalPages());
//     setCurrentPage(gridApi.paginationGetCurrentPage());
//   };

//   updatePagination(); // initial load

//   gridApi.addEventListener('paginationChanged', updatePagination);

//   return () => {
//     gridApi.removeEventListener('paginationChanged', updatePagination);
//   };
// }, [gridApi]);

//   const goToPage = (page) => {
//     gridApi.paginationGoToPage(page);
//     setCurrentPage(page);
//   };

//   const getPageRange = () => {
//     const half = Math.floor(visiblePages / 2);
//     let start = Math.max(currentPage - half, 0);
//     let end = start + visiblePages;

//     if (end > totalPages) {
//       end = totalPages;
//       start = Math.max(end - visiblePages, 0);
//     }

//     return Array.from({ length: end - start }, (_, i) => start + i);
//   };

//   return (
//     <div className="pagination-container">
//       <button
//         disabled={currentPage === 0}
//         onClick={() => goToPage(currentPage - 1)}
//       >
//         &lt;
//       </button>

//       {getPageRange().map((page) => (
//         <button
//           key={page}
//           className={page === currentPage ? "active" : ""}
//           onClick={() => goToPage(page)}
//         >
//           {page + 1}
//         </button>
//       ))}

//       <button
//         disabled={currentPage === totalPages - 1}
//         onClick={() => goToPage(currentPage + 1)}
//       >
//         &gt;
//       </button>
//     </div>
//   );
// };

// export default CustomPagination;

import React, { useEffect, useState } from "react";

const CustomPagination = ({ gridApi }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10); // default

  const visiblePages = 5;

  useEffect(() => {
    if (!gridApi) return;

    const updatePagination = () => {
      setTotalPages(gridApi.paginationGetTotalPages());
      setCurrentPage(gridApi.paginationGetCurrentPage());
    };

    updatePagination();
    gridApi.addEventListener("paginationChanged", updatePagination);

    return () => {
      gridApi.removeEventListener("paginationChanged", updatePagination);
    };
  }, [gridApi]);

  const goToPage = (page) => {
    if (gridApi) {
      gridApi.paginationGoToPage(page);
      setCurrentPage(page);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);

    if (gridApi) {
      gridApi.setGridOption("paginationPageSize", newSize); // ✅ Quartz-compatible
      gridApi.paginationGoToPage(0);
    }

    // if (gridApi && gridApi.paginationSetPageSize) {
    //   gridApi.paginationSetPageSize(newSize);
    //   gridApi.paginationGoToPage(0);
    // }
  };

  const getPageRange = () => {
    const half = Math.floor(visiblePages / 2);
    let start = Math.max(currentPage - half, 0);
    let end = start + visiblePages;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - visiblePages, 0);
    }

    return Array.from({ length: end - start }, (_, i) => start + i);
  };

  return (
    <div className="pagination-container d-flex gap-3 align-items-center">
      {/* Page Size Dropdown */}

      {/* Pagination Buttons */}
      <div className="d-flex align-items-center gap-2">
        <button
          disabled={currentPage === 0}
          onClick={() => goToPage(currentPage - 1)}
        >
          &lt;
        </button>

        {getPageRange().map((page) => (
          <button
            key={page}
            className={page === currentPage ? "active" : ""}
            onClick={() => goToPage(page)}
          >
            {page + 1}
          </button>
        ))}

        <button
          disabled={currentPage === totalPages - 1}
          onClick={() => goToPage(currentPage + 1)}
        >
          &gt;
        </button>
      </div>

      <div className="d-flex align-items-center gap-2">
        {/* <label htmlFor="pageSizeSelect" className="color-gray">Page Size:</label> */}
        <select
          id="pageSizeSelect"
          value={pageSize}
          onChange={handlePageSizeChange}
          className="form-select color-white"
          style={{ width: "100px" }}
        >
          {[10, 20, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CustomPagination;
